<template>
    
    <div>
        <vs-row class="cardGeneral">
            <vs-col class="cardReportes" vs-type="flex" vs-justify="center" vs-align="center" w="12">
                <vs-row>
                    <vs-col sm="12" lg="8">
                        <h4 class="p-2">Subcategorias de servicios</h4>
                    </vs-col>
                    <vs-col sm="6" lg="4">
                         <vs-button
                            success
                            class="ml-auto"
                            @click="activeCrear =! activeCrear"
                        >
                            Crear Registro
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-4">
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off" >
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <template v-if="instituciones.length" autocomplete="off">
                                    <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="cicloEscolar" class="labelInput">
                                Ciclo Escolar
                            </label>
                            <vs-select filter :loading="loadingSelect" class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" v-if="instituciones.length" :disabled="!ciclosEscolares.length" autocomplete="off">
                                <template #message-danger v-if="errorFields.includes('cicloEscolar')">
                                    Requerido
                                </template>
                                <template v-if="ciclosEscolares.length" autocomplete="off">
                                    <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.text" :value="option.id">
                                        {{option.text}}
                                    </vs-option>
                                </template>
                                <template v-else>
                                    <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                                    </vs-option>
                                </template>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                            <label for="codigoDetalle" class="labelInput">
                                Código de detalle
                            </label>
                        <vs-select
                            filter
                            class="pt-0"
                            id="codigoDetalle"
                            placeholder="Seleccionar Código de detalle"
                            v-model="codigoDetalle"
                            :key="codigosDetalleId"
                            :disabled="!codigosDetalle.length"
                        >
                            <vs-option v-for="option in codigosDetalle" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </vs-col>
                    <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                        <vs-button
                            @click="getSubcategoriasServicios()"
                        >
                            <i class="fas fa-search mr-2"></i>Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>

                <tabla-promociones :info="info" :institucionesArray="instituciones" :ciclosEscolaresArray="ciclosEscolares" :filtros="filtros" :codigosDetalle="codigosDetalle" @refreshTable="getSubcategoriasServicios" :filter="filtro"></tabla-promociones>

                <crear v-model="activeCrear" :institucionesArray="instituciones" :ciclosEscolaresArray="ciclosEscolares" :codigosDetalle="codigosDetalle" @refreshTable="getSubcategoriasServicios" ></crear>

            </vs-col>
        </vs-row>
    </div>
</template>
<script>
import academico from '../../../../api/requests/academico'
import reportes from '../../../../api/requests/reportes'
import TablaPromociones from './tabla-promociones.vue'
import crear from './modal/crear.vue'
export default {
    data(){
        return{
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            cicloEscolar: '',
            ciclosEscolares: [],
            cicloId: (new Date()).getTime(),
            codigoDetalle: '',
            codigosDetalle: [],
            codigosDetalleId: (new Date()).getTime(),
            errorFields: [],
            users: [],
            filtro: '',
            info: [],
            filtros:[],
            tache: false,
            activeCrear: false,
            loadingSelect: false
        }
    },
    components:{
        TablaPromociones,
        crear
    },
    created(){
        this.getInstituciones()
        this.getCodigoDetallesServicios()
    },
    methods:{
        selectAll(seleccion, tipo){
              let arr = []
            seleccion.forEach(i => {
              arr.push(i.id)
            })
            if(tipo == 'codigosDetalle'){
                this.codigoDetalle = arr
            }
        },
        deseleccionarAll(tipo){
            if(tipo == 'codigosDetalle'){
                this.codigoDetalle = ''
            }
        },
        async getInstituciones(){
            try {
                const response = await academico.getInstitucion()
                this.instituciones = response.data
            }
            catch{
                
            }
        },
        async getCicloEscolar() {
            this.loadingSelect = true
            const { data: response } = await academico.getCiclosEscolares(this.institucion)
            this.ciclosEscolares = response
            this.cicloId = (new Date()).getTime()
            this.loadingSelect = false
        },
        async getCodigoDetallesServicios(){
            try {
                const response = await academico.getCodigoDetallesServicios()
                this.codigosDetalle = response.data
                this.codigosDetalleId = (new Date()).getTime()
            }
            catch{
                
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.cicloEscolar) {
                this.errorFields.push('cicloEscolar')
            }
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if (!this.errorFields.length){
                const params = {
                    ciclo_escolar_id: this.cicloEscolar,
                    institucion_id: this.institucion
                }
                if(this.codigoDetalle != ''){
                    params.codigo_detalle_id = this.codigoDetalle
                }
                return params
            } else {
                return null
            }
        },
        async getSubcategoriasServicios(){
            const info = this.sanityForm()
            if(info){
                try {
                    const loading = this.$vs.loading()
                    const { data: response } = await academico.getSubcategoriasServicios(info)
                    this.info = response
                    this.filtros = {
                        institucion: this.institucion,
                        cicloEscolar: this.cicloEscolar,
                        codigoDetalle: this.codigoDetalle,
                        codigosDetalles: this.codigosDetalle
                    }
                    loading.close()
                }
                catch{
                    loading.close()
                }
            }
        },
    },
    watch:{
        institucion(){
            this.getCicloEscolar()
        },
    }
}
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 15px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 100%;
        }
    }
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>